import PaymentDetails from './PaymentDetails'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'

import { getCards, createCard } from '../../../store/effects/user'
import { createOrder, applyCoupon } from '../../../store/effects/order'
import { changeSelectedCard, changeCoupon } from '../../../store/actions/order'
import * as userSelectors from '../../../selectors/user'
import * as orderSelectors from '../../../selectors/order'

const mapStateToProps = state => ({
  cards: userSelectors.getCards(state),
  cardsLoading: userSelectors.cardsLoading(state),
  cardsCached: userSelectors.cardsCached(state),
  selectedCard: orderSelectors.getSelectedCard(state),
  userInfo: userSelectors.getUserInfo(state),
  initialCoupon: orderSelectors.getCoupon(state),
  orderConfirmationLoading: orderSelectors.orderConfirmationLoading(state),
  couponLoading: orderSelectors.couponLoading(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCards,
      createCard,
      createOrder,
      changeSelectedCard,
      applyCoupon,
      changeCoupon
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(PaymentDetails)



// WEBPACK FOOTER //
// ./src/modules/Checkout/PaymentDetails/index.js